import "core-js/modules/es.array.map.js";
import classNames from 'classnames';
import styles from "./ComparePlans.module.scss";
import { Fragment } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var ComparePlans = function ComparePlans(_ref) {
  var _ref$headerText = _ref.headerText,
    headerText = _ref$headerText === void 0 ? '' : _ref$headerText,
    _ref$tabName = _ref.tabName,
    tabName = _ref$tabName === void 0 ? '' : _ref$tabName,
    _ref$column1HeaderTex = _ref.column1HeaderText,
    column1HeaderText = _ref$column1HeaderTex === void 0 ? '' : _ref$column1HeaderTex,
    _ref$column2HeaderTex = _ref.column2HeaderText,
    column2HeaderText = _ref$column2HeaderTex === void 0 ? '' : _ref$column2HeaderTex,
    _ref$asteriskText = _ref.asteriskText,
    asteriskText = _ref$asteriskText === void 0 ? '' : _ref$asteriskText,
    _ref$contents = _ref.contents,
    contents = _ref$contents === void 0 ? [] : _ref$contents;
  var getSvgIcon = function getSvgIcon(type) {
    switch (type) {
      case 'notIncluded':
        return /*#__PURE__*/_jsxs("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("circle", {
            cx: "10",
            cy: "10",
            r: "10",
            fill: "#F4F5F9"
          }), /*#__PURE__*/_jsx("path", {
            d: "M12.8926 6.22412C13.1365 5.98035 13.5323 5.98054 13.7764 6.22412C14.0204 6.4682 14.0204 6.86481 13.7764 7.10889L10.8848 9.99951L13.7764 12.8911C14.0204 13.1352 14.0204 13.5308 13.7764 13.7749C13.5323 14.019 13.1367 14.019 12.8926 13.7749L10.001 10.8833L7.11035 13.7749C6.86627 14.019 6.46966 14.019 6.22559 13.7749C5.982 13.5308 5.98182 13.1351 6.22559 12.8911L9.11621 9.99951L6.22559 7.10889C5.98162 6.8648 5.98155 6.46816 6.22559 6.22412C6.46963 5.98008 6.86626 5.98016 7.11035 6.22412L10.001 9.11475L12.8926 6.22412Z",
            fill: "#08070C"
          })]
        });
      case 'included':
        return /*#__PURE__*/_jsxs("svg", {
          width: "20",
          height: "20",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/_jsx("circle", {
            cx: "10",
            cy: "10",
            r: "10",
            fill: "#4F2ACA"
          }), /*#__PURE__*/_jsx("path", {
            d: "M13.7246 6.64062C13.9687 6.39725 14.3645 6.39693 14.6084 6.64062C14.8522 6.88461 14.8521 7.28134 14.6084 7.52539L9.19141 12.9414C8.94738 13.1854 8.55171 13.1853 8.30762 12.9414L5.39062 10.0254C5.14655 9.78131 5.14655 9.3847 5.39062 9.14062C5.63473 8.89687 6.03142 8.89665 6.27539 9.14062L8.74902 11.6152L13.7246 6.64062Z",
            fill: "white"
          })]
        });
      case 'grayIncluded':
        {
          return /*#__PURE__*/_jsxs("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [/*#__PURE__*/_jsx("circle", {
              cx: "10",
              cy: "10",
              r: "10",
              fill: "#5A577D"
            }), /*#__PURE__*/_jsx("path", {
              d: "M13.7246 6.64062C13.9687 6.39725 14.3645 6.39693 14.6084 6.64062C14.8522 6.88461 14.8521 7.28134 14.6084 7.52539L9.19141 12.9414C8.94738 13.1854 8.55171 13.1853 8.30762 12.9414L5.39062 10.0254C5.14655 9.78131 5.14655 9.3847 5.39062 9.14062C5.63473 8.89687 6.03142 8.89665 6.27539 9.14062L8.74902 11.6152L13.7246 6.64062Z",
              fill: "white"
            })]
          });
        }
    }
  };
  var buildContentRow = function buildContentRow(item, idx) {
    if (!item) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.tableColumn1,
        children: item.text
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.subTable, styles.tableColumn2),
        children: [/*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx("div", {
            children: getSvgIcon(item === null || item === void 0 ? void 0 : item.item1Type)
          })
        }), /*#__PURE__*/_jsx("div", {
          children: getSvgIcon(item === null || item === void 0 ? void 0 : item.item2Type)
        })]
      })]
    }, "subTable_".concat(idx));
  };
  return /*#__PURE__*/_jsxs("div", {
    className: styles.comparePlans,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.header,
      children: /*#__PURE__*/_jsx("span", {
        children: headerText
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.table,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.bodyHeader,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.tab,
          children: /*#__PURE__*/_jsx("span", {
            children: tabName
          })
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: classNames(styles.subTable, styles.subTableHeader),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.item1,
          children: column1HeaderText
        }), /*#__PURE__*/_jsx("div", {
          className: styles.item2,
          children: column2HeaderText
        })]
      }), contents && contents.map(function (item, idx) {
        return buildContentRow(item, idx);
      })]
    }), asteriskText && /*#__PURE__*/_jsx("div", {
      className: styles.asterisk,
      children: asteriskText
    })]
  });
};